<div class="panel-heading">
    <button type="button" class="close" (click)="onRemove(ruleCondition)" style="color: #ffffff; margin-left: 10px; display: block">
        &times;
    </button>

    <!-- Minimize/Maximize Arrows -->
    <button (click)="showBody = !showBody" type="button" class="close"style="color: #ffffff; margin-left: 10px;">
        <i *ngIf="showBody" class="fa fa-angle-double-up"></i>
        <i *ngIf="!showBody" class="fa fa-angle-double-down"></i>
    </button>

    <h1 class="panel-title" style="display: inline-block; width: 90%">
        <div style="display: inline-block; width: 150px">
            <i class="fa fa-circle" ></i>&nbsp;{{ruleCondition.sourceType}}
        </div>
        <span style="margin-left: 20px; font-size: 16px;">
            {{getEntityLabel()}} {{getOperatorLabel(ruleCondition.operator)}} {{getValueLabel()}}
        </span>
    </h1>
</div>

<div *ngIf="showBody" class="panel-body" >
	<div class="row panel-body">
		<div class="col-xs-3">
			<span class="input-group">
				<select class="form-control" (ngModelChange)="onPropertyChange($event)"  [(ngModel)]="ruleCondition.property" [ngModelOptions]="{standalone: true}">
					<option [ngValue]="undefined" > {{ruleCondition.sourceType}} </option>
					<option *ngFor="let property of properties" [ngValue]="property.property">
						{{property.name}}
					</option>
				</select>
			</span>
		</div>
		<div class="col-xs-3">
			<span class="dropdown">
				<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					{{getOperatorLabel(ruleCondition.operator)}}
					<span class="caret"></span>
				</button>
				<ul class="dropdown-menu" style="max-height: 250px; overflow-y: auto" >
					<li (click)="onOperatorChange(operator)" *ngFor="let operator of entityOperators">
						<a class="ef">
							{{getOperatorLabel(operator)}}
						</a>
					</li>
				</ul>
			</span>
		</div>
		<div class="col-xs-3">
			<!-- property is not a reference -->
			<input *ngIf="ruleCondition.property != null" class="form-control" type="text" [(ngModel)]="ruleCondition.propertyValue" style="display: inline; width: 200px" />

			<!-- property is a reference -->
			<input *ngIf="ruleCondition.property == null" class="form-control" type="text" [(ngModel)]="typeaheadValue" style="display: inline; width: 200px" 
				[typeahead]="entities"
				(typeaheadLoading)="changeTypeaheadLoading($event)"
				(typeaheadOnSelect)="typeaheadOnSelect($event)"
				typeaheadOptionField="name"
			/>
		</div>
	</div>
</div>